<div>
    <div fxLayout="row" fxFlexAlign="center">
        <h3 class="m-0" style="font-weight:800;">{{'DRIVING_COMPLETION_CONFIRMATION_SCREEN'|translate}}</h3>
    </div>
    <div class="p-20 pl-0">
        <p>{{'ARE_YOU_SURE_YOU_WANT_TO_COMPLETE_THE_JOURNEY'|translate}}</p>
    </div>
    <div class="w-100-p" fxLayout="row" fxLayoutAlign="space-between center">
        <button mat-raised-button (click)="save()" color="primary">{{'YES'|translate}}</button>
        <button mat-raised-button (click)="_dialogRef.close()" color="warn">{{'NO'|translate}}</button>
    </div>
</div>